import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FlowContentItemTable, FlowContentItemTranslation } from '../flows-localization.abstraction';
import { FlowsLocalizationService } from '../flows-localization.service';
import { BotsService } from '@core/bots';
import { take } from 'rxjs';

@Component({
  selector: 'ca-flows-localization-cell',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, MatInputModule],
  templateUrl: './flows-localization-cell.component.html',
  styleUrls: ['./flows-localization-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowsLocalizationCellComponent implements OnInit {
  #flowsLocalizationService = inject(FlowsLocalizationService);
  #botsService = inject(BotsService);
  #destroyRef = inject(DestroyRef);

  localesControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [
      Validators.required,
      () => (this.fieldObj?.reviewRequired ? { reviewRequired: true } : null),
    ],
  });

  item = input.required<FlowContentItemTable>();
  columnName = input.required<string>();
  fieldObj?: FlowContentItemTranslation;

  ngOnInit(): void {
    if (!!this.item() && !!this.columnName()) {
      this.fieldObj = this.item().translationsObj[+this.columnName()];
      this.localesControl.setValue(this.fieldObj?.value);
      this.localesControl.markAsTouched();
    }

    this.#botsService.defaultLocale$
      .pipe(take(1), takeUntilDestroyed(this.#destroyRef))
      .subscribe((defaultLocale) => {
        if(defaultLocale.id === +this.columnName()) {
          this.localesControl.disable();
        }
    });
  }

  changeInput(): void {
    if (this.fieldObj?.value !== this.localesControl.getRawValue()) {
      this.#flowsLocalizationService
        .updateForm(this.fieldObj!.id, this.localesControl.getRawValue())
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe();
    }
  }
}
